










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class PropertyOriginSelector extends Vue {
  @Prop() public origins!: string[];
  public value: string = '';

  public updateSelectedOrigin(origin: string) {
    this.$emit('update', origin);
  }
}
